<template>
  <div>
    <div style="display: flex; align-items: center; width: 100%;">
      <el-select
        v-model="integrationId"
        @change="selectUnit">
        <el-option v-for="(item, index) in integrationList"
                   :key="index" :label="item.alias + item.version" :value="item.id">
          <span style="float: left">{{ item.alias }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.version }}</span>
        </el-option>
      </el-select>

      <el-select v-model="moduleId" placeholder="请选择模块" clearable style="margin-left: 10px"
                 @change="getModuleInfo">
        <el-option
          v-for="item in moduleList"
          :key="item.moduleVersionId"
          :label="item.moduleVersion"
          :value="item.moduleVersionId">
        </el-option>
      </el-select>

      <el-button type="primary" @click="download" style="margin-left: 10px" v-if="btnInList('agent_download')">
        {{ downloadBtnText }}
      </el-button>
      <el-tooltip effect="dark" :content="downloadMsg" placement="top" v-if="downloadMsg">
        <span
          style="color: red; font-size: 13px; flex: 1; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: inline-block;margin-left: 10px">{{
            downloadMsg
          }}</span>
      </el-tooltip>
    </div>
    <el-steps simple finish-status="success" v-if="showStep"
              style="margin-top: 10px">
      <el-step v-for="item in stepList" :key="item.index">
        <el-button slot="title" size="mini" :type="item.buttonType" :disabled="item.disabled"
                   @click="goStep(item)">
          {{ item.title }}
        </el-button>
      </el-step>
    </el-steps>

    <el-table v-if="deviceTable && deviceTable.length > 0"
              :data="deviceTable" style="width: 100%" :height="tableMaxHeight">
      <el-table-column prop="id" label="设备ID"></el-table-column>
      <el-table-column prop="name" label="设备名称"></el-table-column>
      <el-table-column prop="room" label="机房"></el-table-column>
      <el-table-column prop="serviceAgentId" label="agent实例ID">
        <template slot-scope="scope">
          <span v-if="scope.row.newId==0">{{ scope.row.serviceAgentId }}</span>
          <span v-else>{{ scope.row.serviceAgentId }} => {{ scope.row.newId }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="serviceVersion" label="agent版本"></el-table-column>
      <el-table-column prop="desc" label="描述" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.err" style="color: red">{{ scope.row.err }}</span>
          <span v-else>{{ scope.row.desc }}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否升级">
        <template slot-scope="scope">
          <img src="@/assets/open.png" v-if="scope.row.upgrade"
               @click="switchChange(scope.row)" style="cursor: pointer;width: 40px;height: 40px;">
          <img src="@/assets/close.png" v-else
               @click="switchChange(scope.row)" style="cursor: pointer;width: 40px;height: 40px;">
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" v-if="currentItem.index==2 && !scope.row.upgrade" @click="verifyClick(scope.row,'rowClick')">升级验证</el-button>
          <el-dropdown trigger="click" v-if="scope.row.upgrade && showCompare && btnInList('agent_config_diff')"
                       @command="command => compareClick(scope.row, command)">
            <span class="el-dropdown-link">
              配置文件变化<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="template">与模板对比</el-dropdown-item>
              <el-dropdown-item command="old">与旧实例对比</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>


    <!--    配置文件修改-->
    <el-dialog title="配置文件修改" :visible="configVisible" width="1000px" center append-to-body
               @close="configVisible = false">

      <span>新文件</span>

      <span style="margin-left:500px" v-if="isTemplate">模板文件</span>
      <span style="margin-left:500px" v-else>旧实例文件</span>
      <div id="view" style="margin-top: 5px"></div>
      <span slot="footer" class="dialog-footer">
        <!--        点击表格行中的对比按钮时的保存-->
        <el-button type="primary" @click="saveConfig" v-if="btnCompare">保 存</el-button>
        <!--        点击步骤条中的对比按钮时的保存-->
        <el-button type="primary" @click="save" v-else>保 存</el-button>
        <el-button type="primary" @click="configVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import CodeMirror from 'codemirror'
import 'codemirror/addon/lint/lint.css'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/monokai.css'
import 'codemirror/mode/yaml/yaml.js'
import 'codemirror/mode/xml/xml.js'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/addon/lint/lint'
import 'codemirror/addon/lint/yaml-lint'
import 'codemirror/addon/lint/json-lint'
// 代码折叠
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/xml-fold.js'
import 'codemirror/addon/fold/foldcode'
import 'codemirror/addon/fold/foldgutter'
import 'codemirror/addon/fold/brace-fold'
import 'codemirror/addon/fold/comment-fold'
//代码版本差异比较
import 'codemirror/addon/merge/merge.js'
import 'codemirror/addon/merge/merge.css'
import DiffMatchPatch from 'diff-match-patch'
import {mapMutations, mapState} from "vuex";

window.diff_match_patch = DiffMatchPatch;
window.DIFF_DELETE = -1;
window.DIFF_INSERT = 1;
window.DIFF_EQUAL = 0;
export default {
  name: "UpdateAgent",
  data() {
    return {
      verifiedArr: [],
      newTable: [],
      isTemplate: false,
      btnCompare: false,
      newInstanceId: 0,
      showCompare: false,
      integrationList: [],
      moduleList: [],
      integrationId: "",
      moduleId: "",
      downloadBtnText: "下载",
      selectedVersion: "",
      selectedAlias: "",
      selectedModuleVersion: "",
      selectedModuleType: "",
      downloadMsg: "",
      deviceTable: [],
      currentItem: {},
      newCfg: "",
      oldCfg: "",
      configVisible: false,
      yamlleftEditor: null,
      currentConfig: "",
      showStep: false,
      tableMap: new Map(),
      idx: 0,
      stepList: [
        {
          title: '获取设备列表',
          name: 'getdevicelist',
          index: 1,
          buttonType: "default",
          disabled: false,
        }, {
          title: '升级验证',
          name: 'update',
          index: 2,
          buttonType: "default",
          disabled: true,
        }, {
          title: '版本校验',
          name: 'verify',
          index: 3,
          buttonType: "default",
          disabled: true,
        }, {
          title: '配置文件修改',
          name: 'edit',
          index: 4,
          buttonType: "default",
          disabled: true,
        }, {
          title: '批量升级',
          name: 'allupdate',
          index: 5,
          buttonType: "default",
          disabled: true,
        }
      ],
    }
  },
  created() {
    this.findIntegration();
    this.getListOperations('idclist');
  },
  computed: {
    ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
    // 操作按钮是否显示
    btnInList() {
      return (name, childName) => {
        let btn = this.listOperations.filter(op => op.name.includes(name));
        if (!childName) {
          return btn.length > 0
        } else {
          return btn[0].buttonList.some(childOp => childOp.name.includes(childName))
        }
      }
    },
    tableMaxHeight() {
      return `calc(100vh - 210px)`
    }
  },
  watch: {
    downloadBtnText(newVal, oldVal) {
      if (newVal == "下载成功") {
        this.showStep = true;
      }
    },
    'deviceTable': {
      handler(newValue, oldValue) {
        this.idx = newValue.findIndex(item => item.upgrade == true)

      },
      deep: true
    }
  },
  methods: {
    ...mapMutations(['getListOperations']),
    initPage(){
      this.idx=0;
      this.tableMap = new Map();
      this.currentItem={}
      this.verifiedArr=[]
      this.showCompare=false;
      this.moduleId = "";
      this.downloadBtnText = "下载";
      this.downloadMsg = "";
      this.showStep = false;
      this.deviceTable = []
      this.stepList= [
        {
          title: '获取设备列表',
          name: 'getdevicelist',
          index: 1,
          buttonType: "default",
          disabled: false,
        }, {
          title: '升级验证',
          name: 'update',
          index: 2,
          buttonType: "default",
          disabled: true,
        }, {
          title: '版本校验',
          name: 'verify',
          index: 3,
          buttonType: "default",
          disabled: true,
        }, {
          title: '配置文件修改',
          name: 'edit',
          index: 4,
          buttonType: "default",
          disabled: true,
        }, {
          title: '批量升级',
          name: 'allupdate',
          index: 5,
          buttonType: "default",
          disabled: true,
        }
      ]
    },
    // 切换当前行是否升级的状态
    switchChange(row) {
      this.$set(this.deviceTable, this.tableMap.get(row.id), {
        ...this.deviceTable[this.tableMap.get(row.id)],
        upgrade: !row.upgrade
      });
    },
    // 获取集成列表
    findIntegration() {
      this.$axios.get(this.moduleUrl + "integration/Version/findAll")
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.integrationList = data ? data : []
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        }).catch(err => {
        console.log('获取集成-请求失败')
      });
    },
    // 选择集成后，显示该集成下的模块
    selectUnit(id) {
      this.initPage()

      const selectedItem = this.integrationList.find((item) => item.id == id);
      if (selectedItem) {
        this.selectedAlias = selectedItem.alias;
        this.selectedVersion = selectedItem.version;
      } else {
        this.selectedAlias = "";
        this.selectedVersion = "";
      }
      this.$axios
        .get(this.moduleUrl + "integration/Version/" + this.selectedAlias + "/" + this.selectedVersion)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.moduleList = []
            if (data.moduleList && data.moduleList.length > 0) {
              data.moduleList.forEach(element => {
                if (element.moduleName == "service_agent") {
                  this.moduleList.push(element)
                }
              });
            } else {
              this.moduleList = []
            }
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          // loading.close();
        })
        .catch(err => {
          console.log(err);
          // loading.close();
        });
    },
    // 模块信息
    getModuleInfo(id) {
      const selectedItem = this.moduleList.find((item) => item.moduleVersionId == id);
      if (selectedItem) {
        this.selectedModuleType = selectedItem.moduleName;
        this.selectedModuleVersion = selectedItem.moduleVersion;
      } else {
        this.selectedModuleType = "";
        this.selectedModuleVersion = "";
      }
    },
    // 下载
    download() {
      let that = this;
      let url = this.baseUrl3 + "deploy/download/module/" + this.selectedAlias + "/" + this.selectedVersion + "/" + this.selectedModuleType + "/" + this.selectedModuleVersion;
      fetch(url,
        {
          method: 'get',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('网络错误，状态码: ' + response.status);
          }

          const reader = response.body.getReader();
          const decoder = new TextDecoder();
          let buffer = '';

          // 循环读取流数据
          function readStream() {
            reader.read().then(({done, value}) => {
              if (done) {
                console.log('读取完毕');
                return;
              }

              // 解码获取的字节流并拼接
              buffer += decoder.decode(value, {stream: true});

              // 按行处理数据
              let lines = buffer.split('\n');
              buffer = lines.pop(); // 保留最后一行不完整的部分
              console.log(lines)
              lines.forEach(line => {
                if (line) {
                  try {
                    let data = line.split('data: ')[1];
                    let json = JSON.parse(data);

                    if (json.code === 20000) {
                      if (json.data) {
                        that.downloadBtnText = json.data.percent + "%";
                        if (json.data.percent == 100) {
                          that.downloadBtnText = "下载成功";
                        }
                      }
                    } else {
                      that.downloadBtnText = "下载失败";
                      that.downloadMsg = json.msg;
                    }
                  } catch (error) {
                    console.error('解析数据错误:', error);
                  }
                }
              });

              // 继续读取下一段数据
              readStream();
            }).catch(error => {
              console.error('读取流数据失败:', error);
            });
          }

          // 开始读取数据流
          readStream();
        })
        .catch(error => {
          console.error('请求失败:', error);
        });
    },
    // 获取设备列表
    getDevicelist(item) {
      this.$axios.get(this.baseUrl3 + "management3/device/findAll")
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.deviceTable = data;
            this.deviceTable.forEach((item, i) => {
              if (this.selectedModuleVersion == item.serviceVersion) {
                item.upgrade = false;
                item.desc = "版本一致，无需升级"
              } else {
                item.upgrade = true;
              }
              item.newId = 0

              this.tableMap.set(item.id, i);
            });
            item.buttonType = "success";
            item.disabled = true;
            this.stepList[item.index].disabled = false;
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        });
    },
    verifyClick(row, type) {
      row.desc = "正在验证";
      this.verify(row, type)
    },
    verify(device, type) {
      this.$axios.get(this.baseUrl3 + "config/service_agent/check/" + device.serviceAgentId)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            device.desc = "验证成功"
          } else {
            device.desc = msg;
            device.upgrade = false;
            // this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }

          if (type == "rowClick") {

          } else {
            this.verifiedArr.push(device)
            if (this.verifiedArr.length == this.newTable.length) {
              this.currentItem.buttonType = "success";
              this.currentItem.disabled = true;
              this.stepList[this.currentItem.index].disabled = false;
              console.log("所有设备验证完毕")
            }
          }
        });
    },
    // 升级验证
    async updateVerify(device, i) {
      return new Promise((resolve) => {
        // 模拟异步操作
        setTimeout(() => {
          this.verify(device);
          resolve();
        }, 500);

        // 判断是否是最后一个元素
        // if (i == this.lastIdx) {
        //   this.currentItem.buttonType = "success";
        //   this.currentItem.disabled = true;
        //   this.stepList[this.currentItem.index].disabled = false;
        //   console.log(`当前设备是最后一个，id: ${device.id}`);
        // }
      });

    },
    async processDeviceTable() {
      for (let i = 0; i < this.deviceTable.length; i++) {
        const device = this.deviceTable[i];
        if (device.upgrade) {
          await this.updateVerify(device, i); // 传递整个 device 对象
        }
      }
    },
    getConfig() {
      let data = {
        "instanceId": this.deviceTable[this.idx].serviceAgentId,
        "configName": "service-agent.yml",
        "moduleName": "service_agent",
        "moduleVersion": this.deviceTable[this.idx].serviceVersion,
        "location": "config"
      }
      this.$axios.post(this.baseUrl3 + "config/cat/content", data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data) {
              this.versionVerify()
            }
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        }).catch(err => {
        console.log('获取集成-请求失败')
      });
    },
    // 配置文件对比
    compareClick(row, e) {
      if (e == "template") {
        this.isTemplate = true;
      } else {
        this.isTemplate = false;
      }
      this.btnCompare = true;
      this.newInstanceId = row.newId;
      let data = {
        "instanceId": row.newId,
        "oldInstanceId": e == "template" ? 0 : row.serviceAgentId,
        "integrationName": this.selectedAlias,
        "integrationVersion": this.selectedVersion,
        "version": this.selectedModuleVersion
      }
      this.$axios.post(this.baseUrl3 + "config/service_agent/cat/content", data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data) {
              this.newCfg = data.newCfg;
              this.oldCfg = data.oldCfg;
              this.configVisible = true;

              this.$nextTick(function () {
                this.initUI()
              });
            } else {
              this.$message({showClose: true, message: '没有找到配置文件', type: "error"});
            }
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        }).catch(err => {
        console.log('请求失败')
      });
    },
    versionVerify() {
      let data = {
        "instanceId": this.deviceTable[this.idx].serviceAgentId,
        "version": this.selectedModuleVersion
      }
      this.$axios.post(this.baseUrl3 + "config/service_agent/version/diff", data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.currentItem.buttonType = "success";
            this.currentItem.disabled = true;
            if (data) {
              this.newCfg = data.newCfg;
              this.oldCfg = data.oldCfg;
              this.stepList[this.currentItem.index].disabled = false;
            } else {
              this.$message({showClose: true, message: "版本校验成功", type: "success"});
              this.stepList[this.currentItem.index].buttonType = "success";
              this.stepList[this.currentItem.index + 1].disabled = false;
            }
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        }).catch(err => {
        console.log('请求失败')
      });
    },
    initUI() {
      // if (oldCfg == null) return;
      let target = document.getElementById("view");
      target.innerHTML = "";

      this.yamlleftEditor = CodeMirror.MergeView(target, {
        value: this.newCfg,//左侧
        origLeft: null,
        orig: this.oldCfg,//右侧
        lineNumbers: true,//显示行号
        mode: "shell",
        highlightDifferences: true,
        styleActiveLine: true,
        matchBrackets: true,
        connect: 'align',
        readOnly: false,//是否只读
      });

      this.yamlleftEditor.edit.doc.setValue(this.newCfg);
    },
    saveConfig() {
      let data = {
        moduleName: this.selectedModuleType,
        moduleVersion: this.selectedModuleVersion,
        instanceId: this.newInstanceId,
        configName: 'service-agent.yml',
        location: "config",
        content: this.yamlleftEditor.edit.doc.getValue(),
      };
      this.$axios.post(this.baseUrl3 + 'management3/config/update', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.configVisible = false;
          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    save() {
      this.currentConfig = this.yamlleftEditor.edit.doc.getValue()
      this.configVisible = false;
      this.stepList[3].disabled = true;
      this.stepList[3].buttonType = "success";
      this.stepList[4].disabled = false;
    },
    //  批量升级
    batchUpgrade() {
      let that = this;
      let data = {
        integrationName: this.selectedAlias,
        integrationVersion: this.selectedVersion,
        content: this.currentConfig,
        version: this.selectedModuleVersion,
        deviceIds: this.deviceTable.filter(item => item.upgrade == true).map(item => item.id),
      };
      fetch(this.baseUrl3 + "instance/batch/upgrade/service_agent", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "Connection": "keep-alive",
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(data), // 将参数作为 JSON 字符串传递
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('网络错误，状态码: ' + response.status);
          }

          const reader = response.body.getReader();
          const decoder = new TextDecoder();
          let buffer = '';

          // 循环读取流数据
          function readStream() {
            reader.read().then(({done, value}) => {
              if (done) {
                console.log('读取完毕');
                return;
              }

              // 解码获取的字节流并拼接
              buffer += decoder.decode(value, {stream: true});

              // 按行处理数据
              let lines = buffer.split('\n');
              buffer = lines.pop(); // 保留最后一行不完整的部分

              lines.forEach(line => {
                if (line) {
                  try {
                    console.log(line)
                    let data = line.split('data: ')[1];

                    let json = JSON.parse(data);

                    if (json.code === 20000) {
                      let obj = json.data;
                      // console.log(obj)
                      if (obj) {
                        that.$set(that.deviceTable, that.tableMap.get(obj.deviceId), {
                          ...that.deviceTable[that.tableMap.get(obj.deviceId)],
                          desc: obj.msg,
                          err: obj.err,
                          newId: obj.instanceId
                        });
                      } else {
                        that.currentItem.buttonType = "success";
                        that.currentItem.disabled = true;
                        that.showCompare = true;
                      }
                    } else {
                      that.$message({showClose: true, message: json.msg, type: "error"});
                    }
                  } catch (error) {
                    console.error('解析数据错误:', error);
                  }
                }
              });

              // 继续读取下一段数据
              readStream();
            }).catch(error => {
              console.error('读取流数据失败:', error);
            });
          }

          // 开始读取数据流
          readStream();
        })
        .catch(error => {
          console.error('请求失败:', error);
        });
    },
    // 步骤点击
    goStep(item) {
      this.currentItem = item;
      // 获取设备列表
      if (item.index == 1) {
        this.getDevicelist(item)
      } else if (item.index == 2) {
        this.newTable = []
        if (this.deviceTable && this.deviceTable.length > 0) {

          const allUpgradeFalse = this.deviceTable.every(e => !e.upgrade);

          if (allUpgradeFalse) {
            this.$message.warning("没有可升级实例");
            return;
          }
          this.newTable = this.deviceTable.filter(item => item.upgrade == true)

          this.deviceTable.forEach((e, i) => {
            if (e.upgrade) {
              this.$set(this.deviceTable, i, {...e, desc: "等待验证"});
            }
          });
          this.processDeviceTable()
        }
      } else if (item.index == 3) {
        this.getConfig(item)
      } else if (item.index == 4) {
        this.btnCompare = false;
        this.configVisible = true;
        this.$nextTick(function () {
          this.initUI()
        });

      } else if (item.index == 5) {
        this.batchUpgrade()
      }

    }
  }
}
</script>


<style scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-arrow-down {
  font-size: 12px;
}
</style>
